import { Component } from '@angular/core';
import {ParceriaService} from "../../../services/nova-parceria/parceria.service";
import moment from "moment";
import {ComunicacaoService} from "../../../services/comunicacao.service";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-chat-cotacoes',
  templateUrl: './chat-cotacoes.component.html',
  styleUrls: ['./chat-cotacoes.component.scss']
})
export class ChatCotacoesComponent {
  hoje = new Date().setHours(23, 59, 59, 999);
  constructor(
    protected parceriaService: ParceriaService,
    protected comunicacaoService: ComunicacaoService,
    protected deviceDetectorService: DeviceDetectorService,
    protected router: Router,
  ) {}

  protected readonly moment = moment;

  aceiteProposta(p): void {
    const data = {
      propostaId: this.parceriaService.idProposta,
      acao: 'FecharDrawer'
    }
    this.parceriaService.idCotacao = p.id;
    this.comunicacaoService.emitirAcao(data);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/area-parceiro/cotacoes/em-negociacao/aguardando-parceiro/aceitar-proposta/', p.propostaId, p.id]);
    });
  }

  data(value) {
   return new Date(value).setHours(23, 59, 59, 999);
  }

  fechar(): void {
    const data = {
      propostaId: this.parceriaService.idProposta,
      acao: 'DrawerDireitaPropostas'
    }
    this.comunicacaoService.emitirAcao(data);
  }

}
